(function () {
  function closeDrawer(drawer) {
    if (!drawer || !drawer.hasAttribute('open')) return;
    drawer.removeAttribute('open');
  }

  function initHeaderDrawer() {
    const drawer = document.querySelector('[data-header-drawer]');
    if (!drawer) return;

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape') closeDrawer(drawer);
    });

    window.addEventListener('resize', function () {
      if (window.matchMedia('(min-width: 750px)').matches) {
        closeDrawer(drawer);
      }
    });
  }

  function initStickyHeader() {
    const headerGroup = document.querySelector('.shopify-section-group-header-group');
    if (!headerGroup) return;

    const drawer = document.querySelector('[data-header-drawer]');

    function setHeaderHeight() {
      document.documentElement.style.setProperty(
        '--header-height',
        headerGroup.offsetHeight + 'px'
      );
    }

    function setSolidState() {
      const menuOpen = drawer && drawer.hasAttribute('open');
      const scrolled = window.scrollY > 0;
      headerGroup.classList.toggle('is-solid', menuOpen || scrolled);
    }

    setHeaderHeight();
    setSolidState();

    window.addEventListener('scroll', setSolidState, { passive: true });
    window.addEventListener('resize', function () {
      setHeaderHeight();
      setSolidState();
    });

    if (drawer) {
      drawer.addEventListener('toggle', setSolidState);
    }
  }

  function init() {
    initHeaderDrawer();
    initStickyHeader();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
